import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnInit {

  @Input() type = 'button';
  @Input() value = 'Aceptar';
  @Input() style = '';
  @Input() className = 'btn btn-primary rounded-pill px-4 font-weight-bold';
  @Output() clicked: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    switch(this.style) {
      case 'secondary':
        this.className = 'btn btn-outline-primary bg-white rounded-pill text-dark px-4 font-weight-bold'
    }

  }

  confirm() {
		this.clicked.emit(true);
	}

}
